import { render, staticRenderFns } from "./questionTimeSelect.vue?vue&type=template&id=15c3d348&scoped=true&"
import script from "./questionTimeSelect.vue?vue&type=script&lang=js&"
export * from "./questionTimeSelect.vue?vue&type=script&lang=js&"
import style0 from "./questionTimeSelect.vue?vue&type=style&index=0&id=15c3d348&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15c3d348",
  null
  
)

export default component.exports